export const grid = {
  colCount: 12,
  gap: {
    min: 6,
    max: 24,
  },
}
